<template>
  <b-modal
    id="idUpdateRequest"
    hide-footer
    title="Gestionar Instrucciones" modal-class="modal-warning"
    @close="closeModal"
    @show="show"
    centered>
    <div v-if="detailInstruction">
      <p>
        {{ 'OT: ' + detailInstruction.delivery_tracking_number }}
      </p>
      <p>
        {{ 'Gestión: ' + detailInstruction.current_type_name }}
      </p>
      <b-form :validated="true">
        <b-form-checkbox v-model="form.resolved" switch required>
          Marcar como resuelto
        </b-form-checkbox>
        <b-form-select v-model="categoryCode" :options="optionsCategory" required>
          <template #first>
            <b-form-select-option :value="null" disabled>-- Por favor seleccione una opción --</b-form-select-option>
          </template>
        </b-form-select>
      </b-form>
      <extra-fields :extraField="selectedCategory" :options="optionsExtraField" @updateExtraField="ok" :activateFormRender="activateFormRender"></extra-fields>
    </div>
  </b-modal>
</template>
<script>
import BaseServices from '@/store/services/index'
import ExtraFields from '@/views/modules/tickets/components/ExtraFields/ExtraFields.vue'
export default {
  props: ['detailInstruction', 'arrayAnswerCarrier'],
  components: {ExtraFields},
  data() {
    return {
      baseService: new BaseServices(this),
      selected: false,
      form: {},
      selectedCategory: {},
      categoryCode: null,
      optionsExtraField: {
        nameButton: 'Ok',
        loading: false
      },
      activateFormRender: 0,
      optionsCategory: []
    }
  },
  computed: {
    validateForm() {
      const validateCategory = !!this.form.category_code
      const validateTextArea = this.commentRequired ? !!this.form.comment : true
      return validateCategory && validateTextArea
    },
    commentRequired() {
      return !!this.selectedCategory?.comment_required
    },
    dataUser() {
      return this.$session.get('cas_user')
    }
  },
  watch: {
    'categoryCode': {
      handler(value) {
        this.form = {}
        const selectedCategory = this.optionsCategory.find(element => element.code === value)
        this.selectedCategory = selectedCategory || {}
        if (this.selectedCategory) {
          this.addExtraField(this.selectedCategory, {
            label: 'Comentario',
            placeholder: 'Ingrese comentario',
            name: 'comment',
            type: 'textarea',
            validation: this.commentRequired ? 'required' : ''
          })
          this.addExtraField(this.selectedCategory, {
            label: 'Archivo opcional',
            placeholder: 'Subir archivo opcional',
            name: 'file',
            type: 'file',
            validation: ''
          })
        }
        this.activateFormRender++
      }
    }
  },
  methods: {
    addExtraField(category, field) {
      const exists = category.extra_fields?.some(existingField => existingField.name === field.name) || false
      if (!exists) {
        category.extra_fields = [
          ...(category.extra_fields ?? []),
          field
        ]
      }
    },
    ok(value) {
      const dataValue = {}
      const addForm =  value.extra_fields.form
      for (const key in addForm) {
        if (Object.prototype.hasOwnProperty.call(addForm, key)) {
          const type = this.selectedCategory.extra_fields.find(el => el.name === key).type
          const element = addForm[key]
          if (type === 'selector') {
            dataValue[key] = element.code
          } else {
            dataValue[key] = element
          }
        }
      }
      this.form = {
        ...this.form,
        ...dataValue,
        instruction_id: this.detailInstruction.id,
        category_code: this.categoryCode,
        resolved: this.form.resolved ?? false,
        email_user_response: this.dataUser.email
      }
      this.optionsExtraField.loading = true
      const params = {
        shipper_id: this.dataUser.id ? this.dataUser.id : '',
        carrier_code: this.dataUser.global_scope?.carrier_code[0] ?? ''
      }
      this.baseService.callSpecialUploadFile('updateInstructions', null, params, this.dataUser, this.form)
        .then(response => {
          this.$success('La instrucción ha sido actualizada correctamente')
          this.$emit('closeModal')
          this.form = {}
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.optionsExtraField.loading = false
        })
    },
    closeModal() {
      this.$emit('closeModal')
    },
    show() {
      this.category_code = null
      this.selectedCategory = {}
      this.optionsCategory = this.arrayAnswerCarrier.map(element => ({
        ...element,
        value: element.code,
        text: element.name
      }))
    }
  }
}
</script>